<template>
  <div>
    <!--上左右结构框架-->
    <Headbar></Headbar>
    <div class="iframebox">
      <div class="imleft">
        <div>
          <div class="myinfo">
            <div class="avatar"><img src="@/assets/avatar_user.jpg"></div>
            <div class="infodata">
              <div class="usercompany">{{greet}}~{{uscompany}}</div>
              <div class="latelylog">上次登录时间：<p>{{$store.state.lastime}}</p></div>
            </div>
          </div>
          <ul class="itemnavlist">
            <router-link tag='li' to="/partner/organlist"  class="iconfont icon-qiyechaxun_huaban current">机构列表</router-link>
            <router-link tag="li" to="/partner/organadd" class="iconfont icon-icon-zijigou">机构添加</router-link>
            <router-link tag="li" to="/partner/organset" class="iconfont icon-hezuohuobanguanli">机构维护</router-link>
          </ul>
        </div>
      </div>
      <div class="imright">
        <router-view/>
      </div>
    </div>
  </div>
</template>
<script>
//calc
import Headbar from '@/components/headbar'
export default {
  components: {
    Headbar
  },
  data(){
    return{
      greet:'',
      uscompany:''
    }
  }
}
</script>
<style>
body{background-color: #F5F8FC;}
.iframebox{
  padding-top: 90px;
  width:100%;
  height:calc(100% - 90px);
  height:calc( 100vh - 90px);
  display: flex; 
}
.imleft{
  flex: none; 
  width: 200px; 
  overflow-y: auto; 
  display: block;
  background: #4C98E6;
}
.imright{
  flex: auto; 
  display: flex; 
  flex-direction: column; 
  overflow-y: auto; 
  padding:30px 25px 0 25px;
  background: #F5F8FC;
}
.itemnavlist li{
  height:65px;
  line-height:65px;
  color:#fff;
  font-size: 16px;
  cursor: pointer;
}
.itemnavlist li::before{
  font-size: 22px; 
  margin:15px;
}
.itemnavlist li.current{
  background-color:#3A84EC;
  cursor: default;
}
.myinfo{ 
  margin-top: 32px;
  display: table;
  width: 100%;
  clear: both;
  margin-bottom:35px
}
.avatar{
  width:90px;
  height:90px;
  margin:36px auto;
}
.infodata{
  float: left;
}
.infodata{ 
  text-align: center;
  width:100%;
}
.avatar img{
  border-radius: 100%;
  overflow: hidden;
  width:90px;
  height:90px;
}
.usercompany{
  font-size:14px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:20px;
}
.latelylog{
  font-size:12px;
  font-weight:400;
  color:rgba(255,255,255,1);
  line-height:17px;
  margin-top:13px;
}
.latelylog p{
  width: 94%;
}
.lineborder{
  width:200px;
  height:1px;
  opacity:0.2965;
  background-color: #2F77C0; 
}
</style>




// WEBPACK FOOTER //
// src/page/partner/index.vue